import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import { date, DateComponent, InputComponent, LoadingComponent } from "jsl-ui";
import { FundDetailsDTO } from "../../ajax/types/FundDetailsDTO";
import { ExpertController } from "../../ajax/ExpertController";
import { statusNames } from "../constants";


export class MyUploadsComponent implements IJSLComponent {


    private data: FundDetailsDTO[];
    private dataPromise: Promise<FundDetailsDTO[]>;
    private fundDatumFrom: DateComponent = new DateComponent({ style: "width:5.3rem" });
    private fundDatumTo: DateComponent = new DateComponent({ style: "width:5.3rem" });
    private searchTxt: InputComponent = new InputComponent({});

    constructor() {
        this.reloadData();
    }

    public reloadData() {
        this.data = null;
        this.dataPromise = ExpertController.GetMyFunde({
            count: 16,
            fundDatumFrom: this.fundDatumFrom.getValueAsDate(),
            fundDatumTo: this.fundDatumTo.getValueAsDate(),
            searchTxt: this.searchTxt.getValue()
        });
        this.dataPromise.then((data) => {
            this.data = data;
            refresh();
        });
        refresh();
    }

    public getData(): Promise<FundDetailsDTO[]> {
        return this.dataPromise;
    }

    public count(): number {
        return this.data.length;
    }

    public render(): IJSLVNode {
        return <div>
            <h2 style="text-align:center;">Meine Funde</h2>

            <div>
            <label style="display:inline-block;width:9rem;margin-bottom:0">Suche*:</label> {this.searchTxt}<br/>
                    <i style="font-size:0.85em">*(Taxon, Sammler, Bestimmer oder Fundort)</i><br/>
                    <label style="display:inline-block;width:9rem;">Funddatum:</label> {this.fundDatumFrom} -
                    {this.fundDatumTo}
                    <button class="genric-btn default-border" click={() => {
                        this.reloadData();
                    }} style="margin-left:0.5rem">Los</button>
            </div>
            {this.data?.length > 0 ? <div>
                {this.data.map((x) =>
                    <a href={"#status/" + x.fundId} style="display:block;position:relative;color:black;" class="highlight-box mt-10">
                        <a>
                            <div>Taxon: {x.name}</div>
                        </a>
                        <div>
                            Hochgeladen: {date.format(x.erstelltAm)} - Funddatum: {date.format(x.fundDatum)}
                        </div>
                        <div>
                            <strong>Status: {statusNames[x.status]}</strong>
                            <span style="margin-left:1rem;">Bilder: {x.imageCount ?? "-"}</span>
                        </div>

                        <a href={"#status/" + x.fundId} style="position:absolute;right:0;top:0;bottom:0;width:4rem;text-align:center;border-left:solid 2px #f2f2f2;background:#ededed;">
                            <div>Status</div>
                            <img src={"/img/status/" + x.status + ".png"} alt={x.status} />
                        </a>

                    </a>
                )}
            </div> : (this.data == null ? <div>{new LoadingComponent()}</div> : <div></div>)}
        </div>;
    }
}
